const pipeTwo =
  (f: (...a: any) => any, g: (...b: any) => any) =>
  (...args: any) =>
    g(f(...args));
export const pipe = (...fns: any) => fns.reduce(pipeTwo);
